import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0399063911b0014f34ba7_1785037438227_b88eebe2/rd2sign/src/app/sign-up-login-screen/components/AuthScreen.tsx");
